define('app/sf/keys/sf-keys-filter',[],function () {
	return function sfKeys(target) {
		if (angular.isObject(target) || angular.isFunction(target)) {
			return Object.keys(target);
		}
		else {
			return [];
		}
	};
});
